import { render, staticRenderFns } from "./LinkRenderer.vue?vue&type=template&id=8405a3a8&scoped=true&"
import script from "./LinkRenderer.vue?vue&type=script&lang=js&"
export * from "./LinkRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LinkRenderer.vue?vue&type=style&index=0&id=8405a3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405a3a8",
  null
  
)

export default component.exports